import React, {Component} from 'react';
import { Button} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactImageFallback from "react-image-fallback";

import FileService from '../../services/files-service';
import UserService from '../../services/users-service';

class LogoItem extends Component{
  constructor(props){
    super(props);

    this.state = {
      loading:true,
      image_url:null,
      image_upload:null
    }
    this.credentials =  UserService.sharedInstance.getStoredCredentials().loginResponse;
    this.initial_image = 'loader.gif';
    this.fallback_image = 'https://www.freeiconspng.com/uploads/no-image-icon-6.png';

    this.onFileChange = this.onFileChange.bind(this);
    this.onUploadLogo = this.onUploadLogo.bind(this);
    this.onDeleteLogo = this.onDeleteLogo.bind(this);
    this.onDownloadLogo = this.onDownloadLogo.bind(this);
  }

  componentDidMount(){
    this.getLogo();
  }

  getLogo = () =>{
    const {type} = this.props;
    const {data,token_data} = this.credentials;

    const {token}= token_data;
    const license = data[0].User_License;
    const auth_username = data[0].User_ID;
    
    const param = {
      type,
      token,
      license,
      auth_username
    }

    FileService.sharedInstance.getLogo(param,(response) => {
      if(response.success){
        const {data} = response;

        this.setState({ image_url:data });
      }else{
        alert(response.message);
      }
    });
  }

  onFileChange = (e) =>{
    const image_upload = e.target.files[0];

    this.setState({ image_upload });
  }

  onUploadLogo = () =>{
    const that = this;
    const {data,token_data} = this.credentials;
    const {image_upload} = this.state;
    const {notification,type} = this.props;

    if(!image_upload){
      return notification.error('No file attached');
    }

    const {token}= token_data;
    const license = data[0].User_License;
    const auth_username = data[0].User_ID;

    const param = {
      type,
      token,
      license,
      auth_username,
      file:image_upload
    };

    FileService.sharedInstance.uploadLogo(param)
      .then(response => {
          if(response.success){
            const {data} = response;

            that.setState({
              image_url:null,
              image_upload:null
            },() => {
              setTimeout(() => {
                that.setState({ image_url:data });
              },5000);
            });

            notification.success('Successfully Uploaded Logo!');
          }else{
            notification.error(response.message);
          }
      }).catch(err => {
        console.error('Error:',err);

        notification.error('Failed to upload the logo!');
      });
  }

  onDeleteLogo = () =>{
    const that = this;
    const {data,token_data} = this.credentials;
    const {notification,type} = this.props;

    
    const {token}= token_data;
    const license = data[0].User_License;
    const auth_username = data[0].User_ID;

    const param = {
      type,
      token,
      license,
      auth_username,
    };

    FileService.sharedInstance.deleteLogo(param)
      .then(response => {
        if(response.success){
          that.setState({ image_url:null });

          notification.success('Successfully delete Logo!');
        }
      }).catch(err => {
        console.log('Error:',err);

        notification.error('Failed to delete the logo!');
        
      });
  }

  onDownloadLogo = () =>{
    const {image_url} = this.state;

    if(image_url) window.open(image_url);
  }

  renderControls = () =>{
    const {image_url} = this.state;

    if(image_url){
      return (
        <React.Fragment>
          <Button className='logo-action-button' onClick={this.onDeleteLogo}>
              <FontAwesomeIcon className='icon' icon='trash-alt'/>
          </Button>
          <Button className='logo-action-button' onClick={this.onDownloadLogo}>
              <FontAwesomeIcon className='icon' icon='download' />
          </Button>
        </React.Fragment>
      )
    }

    return null;
  }

  renderImage(){
    const {title} = this.props;
    const {image_url} = this.state;

    if(image_url){
      return <img src={image_url} alt={`${title} Here`} className='logo-image main-logo' />
    }

    return (
      <ReactImageFallback
        src={null}
        fallbackImage={this.fallback_image}
        initialImage={this.initial_image}
        alt={`${title} Here`}
        className='logo-image' 
      />
    )
  }

  render(){
    const {title} = this.props;

    return (
      <React.Fragment>
        <div className='logo-div'>
          <h3 className='logo-name'>{title}</h3>
          <input
            type='file'
            ref={(input) => { this.filesInput = input }}
            name='file'
            className='form-control'
            onChange={this.onFileChange}
            accept='image/x-png'
          />
          <Button className='green-btn upload-logo-btn' onClick={this.onUploadLogo}>Upload Logo</Button>
          <div className='logo-image-div'>
              {this.renderImage()}
          </div>
          <div className='logo-controls'>
            <h5 className='logo-size'>MAX: 450 x 450px</h5>
            {this.renderControls()}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default LogoItem;